import { Paper } from "@mui/material";
import { styled } from "@mui/system";

export const StyledTalentCalendarPaper = styled(Paper)({
  padding: 0,
  borderRadius: "12px",
  position: "relative",
  width: "100%",
  minWidth: 860,
  display: "flex",
  backgroundColor: "background",
  flexDirection: "column",
} as any);
